(function () {
  const AEO_QUERY = `
    query GetAeoContents {
      allAeoContents(first: 500) {
        handle
        aeoItems {
          ... on FaqItemRecord {
            title
            body
          }
        }
      }
    }
  `;
  const DATO_URL = 'https://graphql.datocms.com/';
  const DATO_TOKEN = '1099c1c0a613651c486503c8c1b934';
  const DATO_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${DATO_TOKEN}`,
    'X-Exclude-Invalid': 'true',
  };
  const CACHE_TTL = 120000;
  const CACHE_ID = 'AeoContent';

  function findMatchingRecord(records, requestPath) {
    if (!Array.isArray(records) || typeof requestPath !== 'string') return;

    return records.find((record) => {
      const handle = String(record?.handle || '').trim();
      return handle && requestPath.includes(handle);
    });
  }

  function truncateText(value, maxLength = 240) {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    if (text.length <= maxLength) return text;

    const candidate = text.slice(0, maxLength + 1);
    const lastSpace = candidate.lastIndexOf(' ');
    return candidate.slice(0, lastSpace > 0 ? lastSpace : maxLength).trim();
  }

  function renderRecord(record, root, markdown) {
    const firstItem = Array.isArray(record?.aeoItems) ? record.aeoItems[0] : null;
    if (!String(firstItem?.body || '').trim()) return false;

    const title = root.querySelector('[data-aeo-title]');
    const summary = root.querySelector('[data-aeo-summary]');
    const ellipsis = root.querySelector('[data-aeo-ellipsis]');
    const full = root.querySelector('[data-aeo-full]');
    const toggle = root.querySelector('[data-aeo-toggle]');
    if (!title || !summary || !ellipsis || !full || !toggle) return false;

    const items = record.aeoItems.filter((item) =>
      Boolean(String(item?.title || '').trim() || String(item?.body || '').trim())
    );
    let firstBody;
    full.replaceChildren();

    items.forEach((item, index) => {
      if (index > 0 && item.title) {
        const heading = root.ownerDocument.createElement('h3');
        heading.textContent = item.title;
        full.appendChild(heading);
      }

      if (!item.body) return;
      const body = root.ownerDocument.createElement('div');
      body.innerHTML = markdown.render(item.body);
      if (!firstBody) firstBody = body;
      full.appendChild(body);
    });

    title.textContent = firstItem.title || '';
    title.hidden = !title.textContent;
    summary.textContent = truncateText(firstBody.textContent);

    function setExpanded(expanded) {
      summary.hidden = expanded;
      ellipsis.hidden = expanded;
      full.hidden = !expanded;
      toggle.hidden = false;
      toggle.textContent = expanded ? 'Read Less' : 'Read More';
      toggle.setAttribute('aria-expanded', String(expanded));
    }

    toggle.addEventListener('click', () => {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    setExpanded(false);
    root.hidden = false;
    return true;
  }

  async function load(root, fetcher, markdown) {
    const payload = await fetcher(
      DATO_URL,
      CACHE_TTL,
      CACHE_ID,
      DATO_HEADERS,
      JSON.stringify({ query: AEO_QUERY })
    );

    if (payload.errors?.length) throw new Error('Dato returned GraphQL errors');

    const record = findMatchingRecord(
      payload?.data?.allAeoContents,
      root.dataset.requestPath || ''
    );
    return record ? renderRecord(record, root, markdown) : false;
  }

  async function init(runtime = globalThis) {
    const root = runtime.document?.querySelector('[data-aeo-content]');
    if (
      !root ||
      typeof runtime.markdownit !== 'function' ||
      typeof runtime.fetchWithIndexedDB !== 'function'
    ) {
      return false;
    }

    const markdown = runtime.markdownit({ html: false, linkify: true, breaks: true });
    return load(root, runtime.fetchWithIndexedDB.bind(runtime), markdown);
  }

  const api = { AEO_QUERY, findMatchingRecord, truncateText, renderRecord, load, init };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  const start = () => {
    init().catch((error) => console.error('Unable to load AEO content.', error));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
